import WOW from 'wow.js'

export default defineNuxtPlugin(() => {
  const isMobile = window.innerWidth < 768 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)
  if (!isMobile) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    new WOW().init()
  }
})
